import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';

// /RefreshTokenSuccess?closeTab=true: the end of the new-tab sign-in started by /RefreshToken. Tells the framed
// /RefreshToken (same origin) that a session exists now, then closes the tab.
export const RefreshTokenSuccess: React.FC = () => {
    useEffect(() => {
        if (window.opener) {
            window.opener.postMessage({ name: 'RefreshTokenSuccess' }, window.location.origin);
        }
        if (new URLSearchParams(window.location.search).get('closeTab') === 'true') {
            const timer = window.setTimeout(() => window.close(), 15 * 1000);
            return () => window.clearTimeout(timer);
        }
    }, []);

    return (
        <Box className="center">
            <Typography>You are logged in successfully. Please close this tab and continue using the application.</Typography>
        </Box>
    );
};
